<template>
  <div>
    <div class="fixed top-0 w-full pt-[8px] bg-white">
      <NavBar />
    </div>
    <div>
      <div class="w-[400px] h-auto px-10 top-[75px] mt-[25px] sm:fixed">
        <!-- <a href="#" v-scroll-to="'#class1'">class 1</a> -->
        <!-- expansion panels  -->
        <div class="w-1/2">
          <div style="overflow: scroll; height: 550px; width: 350px">
            <div v-for="(item, i) in items" :key="i" class="px-10">
              <Acc
                class="rounded"
                :title="item.title"
                :class="`bg-[${item.color}] text-[${item.text_color}]`"
              >
                <div v-for="(item2, j) in item.children" :key="j">
                  <Acc
                    :title="item2.title"
                    :class="`text-[${item2.text_color}] bg-[${item2.color}]`"
                  >
                    <div v-for="(item3, j) in item2.children" :key="j">
                      <!-- <Acc :title="item3.title"></Acc> -->
                      <button
                        v-scroll-to="item3.scroll_to"
                        class="
                          w-full
                          hover:text-red-900 hover:bg-gray-200
                          p-2
                          flex
                        "
                      >
                        {{ item3.title }}
                      </button>
                    </div>
                  </Acc>
                </div>
              </Acc>
            </div>
          </div>
        </div>
      </div>
      <div class="flex justify-center">
        <div class="sm:ml-[250px] sm:px-10 mt-[75px] min-w-[750px] w-1/2">
          <ListOfPaymentFacilities
            class="class1"
            :hTitle="'List of Payment Facilities'"
          />
          <RemindersOfPayments
            class="class2"
            :hTitle="'Reminders of Payments'"
          />
          <RegistrationFee class="class3" :hTitle="'Registration Fee'" />
          <RealPropertyTax class="class4" :hTitle="'Real Property Tax'" />
          <InHouseFinancingIntro class="class5" :hTitle="'InHouse Financing'" />
          <InHouseFinancingDownpayment class="class6" :hTitle="'Downpayment'" />
          <InHouseFinancingMonthlyAmort
            class="class67"
            :hTitle="'Monthly Amortization'"
          />
          <InHouseFinancingPenalties class="class7" :hTitle="'Penalties'" />
          <MoveinTurnoverRequirements
            class="class8"
            :hTitle="'Move-in Turnover Requirements'"
          />
          <DocumentsRequired class="class10" :hTitle="'Documents Required'" />
          <PaymentsRequired class="class11" :hTitle="'Payments Required'" />
          <InHouseMonetary
            class="class12"
            :hTitle="'InHouse Financing Monetary Requirements'"
          />
          <InHouseRequirements
            class="class13"
            :hTitle="'InHouse Financing Documentary Requirements'"
          />
          <!-- <BankingMonetary
            class="class14"
            :hTitle="'Banking Financing Monetary Requirements'"
          /> -->
          <!-- <BankingRequirements
            class="class15"
            :hTitle="'Banking Financing Documentary Requirements'"
          /> -->
          <!-- ====bank financing -->
          <div>
            <!-- <BankFinancing-Process
              class="classBank1 pt-[25px]"
              :hTitle="'Process'"
            /> -->
            <BankFinancing-requirements-from-buyer
              class="classBank2 pt-[25px]"
              :hTitle="'Requirements from Buyer'"
            />
            <BankFinancing-requirements-from-developer
              class="classBank3 pt-[25px]"
              :hTitle="'Requirements from Developer'"
            />
            <BankFinancing-accredited-banks
              class="classBank4"
              :hTitle="'Accredited Banks'"
            />
            <!-- <BankFinancing-Process
              class="classBank1 pt-[25px]"
              :hTitle="'Process'"
            /> -->
          </div>
          <BankingMonetary
            class="class14"
            :hTitle="'Banking Financing Monetary Requirements'"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import tree from "./tree.js";
/* eslint-disable */
// import ExpansionPaneltext from "./components/ExpansionPaneltext.vue";
import ListOfPaymentFacilities from "./scrollVersion/screens/billingPayments/ListOfPaymentFacilities.vue";
import RemindersOfPayments from "./scrollVersion/screens/billingPayments/RemindersOfPayments.vue";
import RegistrationFee from "./scrollVersion/screens/billingPayments/RegistrationFee.vue";
import RealPropertyTax from "./scrollVersion/screens/billingPayments/RealPropertyTax.vue";
import NavBar from "../../common/NavBar-Fixed.vue";
import Acc from "./components/Accordion.vue";
import InHouseFinancingDownpayment from "./scrollVersion/screens/financingScheme/InHouseFinancing-DownPayment.vue";
import InHouseFinancingIntro from "./scrollVersion/screens/financingScheme/InHouseFinancing-Intro.vue";
import InHouseFinancingPenalties from "./scrollVersion/screens/financingScheme/InHouseFinancing-Penalties.vue";
import InHouseFinancingMonthlyAmort from "./scrollVersion/screens/financingScheme/InHouseFinancing-MonthlyAmort.vue";
import MoveinTurnoverRequirements from "./scrollVersion/screens/moveinTurnover/Requirements.vue";
import DocumentsRequired from "./scrollVersion/screens/moveinTurnover/Documents.vue";
import PaymentsRequired from "./scrollVersion/screens/moveinTurnover/Payments.vue";
import InHouseMonetary from "./scrollVersion/screens/titleTransfer/InHouse-Monetary.vue";
import InHouseRequirements from "./scrollVersion/screens/titleTransfer/InHouse-Requirements.vue";
import BankingMonetary from "./scrollVersion/screens/titleTransfer/Banking-Monetary.vue";
import BankingRequirements from "./scrollVersion/screens/titleTransfer/Banking-Requirements.vue";

import BankFinancingProcess from "./scrollVersion/screens/financingScheme/bank-financing/BankFinancing-Process.vue";
import BankFinancingRequirementsFromBuyer from "./scrollVersion/screens/financingScheme/bank-financing/BankFinancing-requirements-from-buyer.vue";
import BankFinancingRequirementsFromDeveloper from "./scrollVersion/screens/financingScheme/bank-financing/BankFinancing-requirements-from-developer.vue";
import BankFinancingAccreditedBanks from "./scrollVersion/screens/financingScheme/bank-financing/BankFinancing-accredited-banks.vue";

export default {
  components: {
    InHouseMonetary,
    InHouseRequirements,
    BankingMonetary,
    BankingRequirements,
    MoveinTurnoverRequirements,
    DocumentsRequired,
    PaymentsRequired,
    ListOfPaymentFacilities,
    RemindersOfPayments,
    RegistrationFee,
    RealPropertyTax,
    NavBar,
    InHouseFinancingDownpayment,
    InHouseFinancingIntro,
    InHouseFinancingPenalties,
    InHouseFinancingMonthlyAmort,
    // ExpansionPaneltext,
    Acc,
    BankFinancingProcess,
    BankFinancingRequirementsFromBuyer,
    BankFinancingRequirementsFromDeveloper,
    BankFinancingAccreditedBanks,
  },
  data() {
    return {
      show: false,

      items: [
        {
          title: "Billing Payments",
          color: "#1F387D",
          text_color: "#fff",
          id: 1,
          children: [
            {
              title: "Payment",
              id: 2,
              color: "#fff",
              text_color: "#000",
              children: [
                {
                  title: "List of Payment Facilities",
                  scroll_to: ".class1",
                  id: 3,
                },
                {
                  title: "Reminders of Payment",
                  scroll_to: ".class2",
                  id: 4,
                },
              ],
            },
            {
              title: "Registration Fee / Real Property Tax",
              id: 5,
              color: "#fff",
              text_color: "#000",
              children: [
                {
                  title: "Registration Fee",
                  scroll_to: ".class3",
                  id: 6,
                },
                {
                  title: "Real Property Tax",
                  scroll_to: ".class4",
                  id: 7,
                },
              ],
            },
          ],
        },
        {
          title: "Financing Scheme",
          id: 8,
          text_color: "#fff",
          color: "#1F387D",
          children: [
            {
              title: "Inhouse Financing",
              id: 9,
              color: "#fff",
              text_color: "#000",
              children: [
                {
                  title: "Inhouse Financing",
                  scroll_to: ".class5",
                  id: 10,
                },
                {
                  title: "Down Payment",
                  scroll_to: ".class6",
                  id: 11,
                },
                {
                  title: "Monthly Amortization",
                  scroll_to: ".class67",
                  id: 11,
                },
                {
                  title: "Penalties",
                  scroll_to: ".class7",
                  id: 12,
                },
              ],
            },
            {
              title: "Bank Financing",
              id: 13,
              color: "#fff",
              text_color: "#000",
              children: [
                // {
                //   title: "Monthly Amortization",
                //   scroll_to: ".class8",
                //   id: 14,
                // },
                {
                  title: "Process",
                  // scroll_to: ".classBank1",
                  children: [
                    {
                      title: "Bank Financing",
                      scroll_to: ".class8",
                    },
                  ],
                },
                {
                  title: "Requirements from Buyer",
                  scroll_to: ".classBank2",
                  id: 16,
                },
                {
                  title: "Requirements from Developer",
                  scroll_to: ".classBank3",
                  id: 17,
                },
                {
                  title: "Accredited Banks",
                  scroll_to: ".classBank4",
                  id: 18,
                },
              ],
            },
          ],
        },
        {
          title: "Move-in Turnover",
          id: 15,
          text_color: "#fff",
          color: "#1F387D",
          children: [
            {
              title: "Move-in Turnover Requirements",
              id: 16,
              color: "#fff",
              text_color: "#000",
              children: [
                {
                  title: "Move-in / Turnover",
                  scroll_to: ".class9",
                },
                {
                  title: "Documents Required",
                  scroll_to: ".class10",
                },
                {
                  title: "Payments Required",
                  scroll_to: ".class11",
                },
              ],
            },
          ],
        },
        {
          title: "Title Transfer",
          id: 17,
          text_color: "#fff",
          color: "#1F387D",
          children: [
            {
              title: "Inhouse Financing",
              id: 18,
              color: "#fff",
              text_color: "#000",
              children: [
                {
                  title: "Monetary Requirements",
                  scroll_to: ".class12",
                  id: 19,
                },
                {
                  title: "Documents Requirements",
                  scroll_to: ".class13",
                  id: 20,
                },
              ],
            },
            {
              title: "Bank Financing",
              id: 21,
              color: "#fff",
              text_color: "#000",
              children: [
                {
                  title: "Bank Financing Requirements",
                  scroll_to: ".class14",
                  id: 22,
                },
                // {
                //   title: "Documents Requirements",
                //   scroll_to: ".class15",
                //   id: 23,
                // },
              ],
            },
          ],
        },
      ],

      // parent: [
      //   {
      //     title: "Payment",
      //     id: 11,
      //     children: [
      //       {
      //         title: "List of Payment Facilities",
      //         scroll_to: ".class1",
      //         id: 12,
      //       },
      //       {
      //         title: "Reminders of Payment",
      //         scroll_to: ".class2",
      //         id: 13,
      //       },
      //     ],
      //   },
      //   {
      //     title: "Registration Fee / Real Property Tax",
      //     id: 14,
      //     children: [
      //       {
      //         title: "Registration Fee",
      //         scroll_to: ".class3",
      //         id: 15,
      //       },
      //       {
      //         title: "Real Property Tax",
      //         scroll_to: ".class4",
      //         id: 16,
      //       },
      //     ],
      //   },
      //   // {
      //   //   title: "Submit Proof of Payment",
      //   //   id: 3,
      //   // },
      // ],
      // items: [
      //   {
      //     title: "List of Payment Facilities",
      //     scroll_to: ".class1",
      //   },
      //   {
      //     title: "Reminders of Payment",
      //     scroll_to: ".class2",
      //   },
      //   {
      //     title: "Registration Fee",
      //     scroll_to: ".class3",
      //   },
      //   {
      //     title: "Real Property Tax",
      //     scroll_to: ".class4",
      //   },
      // ],
    };
  },
};
</script>
